define([
    "base/utils/utility"],
    function (
        utils) {
        "user strict";
        const unifyValid = window.tinyWidget.UnifyValid;
        unifyValid.focusFirst = function (elements) {
            var unifyValidThis = this;
            var isValid;
            // elements参数可为 校验元素数组/校验元素父容器
            var validElements = this._parseElements(elements);
            var $element;
            // 循环元素列表
            for (var i = 0, len = validElements.length; i < len; i++) {
                $element = $(validElements[i]).filter("[validator]");
                $element = !$element.length ? $(validElements[i]).find("[validator]") : $element;
                if (!$element.length) {
                    break;
                }
                //特殊情况处理，包括:
                //不进行校验的情况：1）元素不显示(IP控件 input是隐藏的，所以此处是通过eleInput来判断元素是否显示的)；
                //2）元素处于disable状态（控件变为disabled状态时，清除其校验信息）
                if ($element.data("eleTip").is(":hidden")) {
                    continue;
                }
                //各控件disable状态可否通过 disabled 属性区分
                if ($element.attr("disabled")) {
                    continue;
                }
                isValid = unifyValidThis._check($element);
                if (!isValid) {
                    $($element).focus();  //使得第一个校验失败的输入框提示错误信息
                    break;
                }
            }
        };

        function IAMValidator(i18n) {
            this.i18n = i18n;
            this.unifyValid = unifyValid;
            this.directValidator = new DirectValidator(i18n);
        }

        IAMValidator.prototype.notBlank = function (cannotContainBlank) {
            var i18n = this.i18n;
            return {
                validFn : function (){
                    var value = this.val();

                    if(cannotContainBlank !== undefined && cannotContainBlank )
                    {
                        if (value == undefined || value.length === 0 || value.toString().indexOf(" ") !== -1) {
                            return i18n("emptyTxt");
                        }
                        return "";
                    }

                    if (value == undefined || value.length === 0) {
                        return i18n("blankTxt");
                    }
                    return "";
                }
            };
        };

        IAMValidator.prototype.maxLen = function (maxLen, errorDetail) {
            var i18n = this.i18n;
            var maxLenNum = Number(maxLen);
            if (isNaN(maxLenNum))
            {
                maxLenNum = 255;
            }
            if(errorDetail === undefined)
            {
                errorDetail = i18n("maxLenTxt");
            }
            return {
                validFn: "maxSize",
                params: [maxLenNum],
                errorDetail: utils.i18nFormat(errorDetail, maxLenNum)
            };
        };

        IAMValidator.prototype.minLen = function (minLen, errorDetail) {
            var i18n = this.i18n;
            var minLenNum = Number(minLen);
            if (isNaN(minLenNum))
            {
                minLenNum = 0;
            }
            if(errorDetail === undefined)
            {
                errorDetail = i18n("minLenTxt");
            }
            return {
                validFn: "minSize",
                params: [minLenNum],
                errorDetail: utils.i18nFormat(errorDetail, minLenNum)
            };
        };

        IAMValidator.prototype.validInput = function (regExpStr, errorDetail) {
            return {
                validFn: function (){
                    var value = this.val();
                    if(value === undefined || value === "")
                    {
                        return true;
                    }
                    var pattern = new RegExp(regExpStr);
                    return pattern.test(value);
                },
                errorDetail: errorDetail
            };
        };

        IAMValidator.prototype.notEqualOrInvert = function (compareId, errorDetail) {
            return {
                validFn: function (params){
                    var userName = "";
                    try
                    {
                        var userNameWidget = $("#" + params[0]).widget();
                        if(userNameWidget)
                        {
                            userName = userNameWidget.getValue();
                        }
                        else
                        {
                            try
                            {
                                //目前只支持span类型的
                                userName = $("#" + params[0])[0].innerHTML;
                            }
                            catch (e)
                            {
                                //如果在dom查找不到，则传入的ID即为用户名
                                userName = compareId;
                            }
                        }
                    }
                    catch (ex)
                    {
                        userName = compareId;
                    }
                    var pwd = this.val();
                    if(userName.toLowerCase() === pwd.toLowerCase())
                    {
                        return false;
                    }
                    if(pwd.toLowerCase() === userName.split("").reverse().join("").toLowerCase())
                    {
                        return false;
                    }
                    return true;
                },
                params: [compareId],
                errorDetail: errorDetail
            };
        };

        IAMValidator.prototype.equal = function (compareId, errorDetail) {
            return {
                validFn: function (params) {
                    return $("#" + params[0]).widget().getValue() === this.val();
                },
                params: [compareId],
                errorDetail: errorDetail
            };
        };

        IAMValidator.prototype.unequal = function(compareId, errorDetail) {
            return {
                "validFn": function(params) {
                    return $("#" + params[0]).widget().getValue() !== this.val()
                },
                "params": [compareId],
                "errorDetail": errorDetail
            }
        };

        IAMValidator.prototype.pwdLevelCheck = function () {
            var i18n = this.i18n;
            return {
                validFn: function () {
                    var pwd = this.val();
                    var strengthLevel = utils.getPwdStrengthLevel(pwd);
                    return strengthLevel === "high" ||  strengthLevel === "mid"? true : false;
                },
                errorDetail: i18n("passwordChars")
            };
        };


        IAMValidator.prototype.emailCheck = function () {
            var i18n = this.i18n;
            return {
                validFn: "email",
                errorDetail: i18n("validEmail")
            };
        };

        IAMValidator.prototype.checkCountryCode = function(codeArray,errorDetail){
            var i18n = this.i18n;
            return {
                validFn:function(){
                    var value = this.val();
                    if(value === undefined || value === "")
                    {
                        return true;
                    }
                    for(var i = 0;i <codeArray.length;i++){
                        if(value === codeArray[i]){
                            return true;
                        }
                    }
                    return false;
                },
                errorDetail:errorDetail
            };
        }
        
        IAMValidator.prototype.checkCharLength = function (maxLen) {
            var i18n = this.i18n;
            return {
                validFn: function () {
                    var value = this.val();
                    var charLength = 0;
                    for (var i = 0; i < value.length; i++){
                        if ((value.charCodeAt(i)>=0) && (value.charCodeAt(i)<=255)){
                            charLength = charLength +1;
                        }
                        else{
                            charLength = charLength +2;
                        }
                    }
                    if (charLength > maxLen){
                        return false;
                    }
                    return true;
                },
                errorDetail: utils.i18nFormat(i18n("maxLenTxt"), maxLen)
            };
        };
        
        IAMValidator.prototype.phoneCheck = function () {
            var i18n = this.i18n;
            return {
                validFn: function () {
                    var num = this.val();
                    var pattern = /^[0-9]\d*$/;
                    return pattern.test(num);
                },
                errorDetail: i18n("validPhone")
            };
        };

        IAMValidator.prototype.phoneAddCheck = function () {
            var i18n = this.i18n;
            return {
                validFn: function () {
                    var num = this.val();
                    var pattern = /^1\d{10}$/;
                    return pattern.test(num);
                },
                errorDetail: i18n("validPhone")
            };
        };

        IAMValidator.prototype.phoneAddCheckIntl = function () {
            var i18n = this.i18n;
            return {
                validFn: function () {
                    var num = this.val();
                    var pattern = /^\d{1,25}$/;
                    return pattern.test(num);
                },
                errorDetail: i18n("validPhone")
            };
        };

        IAMValidator.prototype.msgCodeCheck = function () {
            var i18n = this.i18n;
            return {
                validFn: function () {
                    var num = this.val();
                    var pattern = /^[a-zA-Z0-9]*$/;
                    return pattern.test(num);
                },
                errorDetail: i18n("commonContainsChar")
            };
        };

        IAMValidator.prototype.smsMsgCodeCheck = function () {
            var i18n = this.i18n;
            return {
                validFn: function () {
                    var num = this.val();
                    var pattern = /^[0-9]*$/;
                    return pattern.test(num);
                },
                errorDetail: i18n("msgCodeErrorInfo")
            };
        };

        IAMValidator.prototype.limitLength = function (length) {
            return {
                validFn: function () {
                    var value = this.val();
                    if(value === undefined)
                    {
                        return true;
                    }
                    value = value.toString();
                    if (value.length > length)
                    {
                        this.val(value.substring(0, length));
                    }
                    return true;
                }
            };
        };

        IAMValidator.prototype.maxRptCharTimes = function (numOfRptCharInPwd) {
            var i18n = this.i18n;
            return {
                validFn: function (){
                    var value = this.val();
                    return utils.maxRptCharTimes(value, numOfRptCharInPwd);
                },
                errorDetail: utils.i18nFormat(i18n("passwordPolicy.errorMsgOfRptChar"), numOfRptCharInPwd)
            };
        };

        IAMValidator.prototype.getCompoundValidator = function () {
            var me = this;
            return {
                required: function (){
                    return [me.notBlank()];
                },
                notBlank: function (cannotContainBlank){
                    return me.notBlank(cannotContainBlank);
                },
                maxLen: function (maxLen, errorDetail){
                    return [me.maxLen(maxLen, errorDetail)];
                },
                minLen: function (minLen){
                    return [me.minLen(minLen)];
                },
                commonValidInput: function (){
                    return [
                        me.limitLength(255),
                        me.validInput("^[\u4e00-\u9fa5a-zA-Z0-9\\_\\- ]+$", me.i18n("commonContainsChar")),
                        me.maxLen(255)
                    ];
                },
                name: function (policy){
                    var accountPolicy = policy.accountpolicy;
                    var minLength, maxLength;
                    $.ajaxSettings.async = false;
                    $.getJSON('/authui/public/base/settings.json', function(data){
                        minLength = data.accountMinLen;
                        maxLength = data.accountMaxLen;
                    });
                    $.ajaxSettings.async = true;
                    return [
                        me.limitLength(128),
                        me.notBlank(true),
                        me.validInput(accountPolicy.username_contains_char, me.i18n("nameContainsChar")),
                        me.minLen(minLength),
                        me.maxLen(maxLength)
                    ];
                },
                password: function (policy, userNameId, pwdMinLen, numOfRptCharInPwd, oldpwdId){
                    var pwdPolicy = policy.passwordpolicy;
                    var validators = [
                        me.notBlank(false),
                        me.minLen(pwdMinLen),
                        me.maxRptCharTimes(numOfRptCharInPwd),
                        me.maxLen(pwdPolicy.password_maxlen)
                    ];

                    if(userNameId && pwdPolicy.pwd_not_is_the_username_or_invert === "true")
                    {
                        validators.push(me.notEqualOrInvert(userNameId, me.i18n("pwdNotUsernameOrInvert")));
                    }

                    if(oldpwdId) {
                        validators.push(me.unequal(oldpwdId, me.i18n("pwdSame")));
                    }
                    validators.push(me.pwdLevelCheck());
                    validators.unshift(me.limitLength(33));
                    return validators;
                },
                email: function (){
                    return [
                        me.limitLength(300),
                        me.notBlank(true),
                        me.emailCheck(),
                        me.maxLen(255),
                        me.checkCharLength(255)
                    ];
                },
                phone: function (phoneLen){
                    return [
                        me.limitLength(128),
                        me.notBlank(true),
                        me.phoneCheck(),
                        me.maxLen(phoneLen, me.i18n("phoneMaxLenTxt"))
                    ];
                },
                phoneAdd: function (){
                    return [
                        me.limitLength(11),
                        me.notBlank(true),
                        me.phoneAddCheck(),
                        me.maxLen(11, me.i18n("phoneMaxLenTxt"))
                    ];
                },
                phoneAddIntl: function (){
                    return [
                        me.limitLength(25),
                        me.notBlank(true),
                        me.phoneAddCheckIntl(),
                        me.maxLen(25, me.i18n("phoneMaxLenTxt"))
                    ];
                },
                countryCode: function(codeArray){
                return [
                    me.limitLength(128),
                    me.notBlank(),
                    me.checkCountryCode(codeArray,me.i18n("inValidCountryCode"))
                    ];
                },                   
                passwordLevel: function (lowId, midId, highId){
                    return utils.pwdLevel4Display(lowId, midId, highId);
                },
                confirmPwd: function (pwdId){
                    return [
                        me.limitLength(33),
                        me.notBlank(),
                        me.equal(pwdId, me.i18n("passwordEqual"))
                    ];
                },
                msgCode: function (){
                    return [
                        me.limitLength(8),
                        me.notBlank(true),
                        me.msgCodeCheck(),
                        me.maxLen(8, me.i18n("maxLenTxt"))
                    ];
                },
                msgCodeForHC: function (){
                    return [
                        me.limitLength(6),
                        me.notBlank(true),
                        me.msgCodeCheck(),
                        me.maxLen(6, me.i18n("maxLenTxt"))
                    ];
                },
                mfaCode: function () { //mfa校验
                    return [
                        me.limitLength(6),
                        me.notBlank(true),
                        me.smsMsgCodeCheck(),
                        me.maxLen(6, me.i18n("maxLenTxt"))
                    ]
                },
                smsMsgCode: function (){
                    return [
                        me.limitLength(6),
                        me.notBlank(true),
                        me.smsMsgCodeCheck(),
                        me.maxLen(6, me.i18n("maxLenTxt"))
                    ];
                },
                graphVerifyCode: function (){
                    return [
                        me.limitLength(4),
                        me.notBlank(),
                        me.maxLen(4)
                    ];
                },
                childValidator: me
            }
        };

        IAMValidator.prototype.getCompoundDirectValidator = function () {
            var me = this;
            var dv = me.directValidator;
            return {
                required: function (value){
                    return dv.notBlank(value);
                },
                notBlank: function (value, cannotContainBlank){
                    return dv.notBlank(value, cannotContainBlank);
                },
                notEmpty: function (value, cannotContainBlank){
                    return dv.notEmpty(value, cannotContainBlank);
                },
                maxLen: function (value, maxLen, errorDetail){
                    return dv.maxLen(value, maxLen, errorDetail);
                },
                minLen: function (value, minLen){
                    return dv.minLen(value, minLen);
                },
                commonValidInput: function (value){
                    var retObj = dv.validInput(value, "^[\u4e00-\u9fa5a-zA-Z0-9\\_\\- ]+$", me.i18n("commonContainsChar"));
                    if (!retObj.result) {
                        return retObj;
                    }
                    retObj = dv.maxLen(value);
                    return retObj;
                },
                name: function (value, policy){
                    var accountPolicy = policy.accountpolicy;
                    var minLength, maxLength;
                    var retObj = dv.notBlank(value, false);
                    if (!retObj.result) {
                        return retObj;
                    }
                    retObj = dv.validInput(value, "^[a-zA-Z\\_\\- ][0-9a-zA-Z\\_\\- ]*$", me.i18n("nameContainsChar"));
                    if (!retObj.result) {
                        return retObj;
                    }
                    $.ajaxSettings.async = false;
                    $.getJSON('/authui/public/base/settings.json', function(data){
                        minLength = data.accountMinLen;
                        maxLength = data.accountMaxLen;
                    });
                    $.ajaxSettings.async = true;
                    if(minLength < 1){
                        minLength = 1;
                    }
                    if(maxLength > 64){
                        maxLength = 64;
                    }
                    retObj = dv.minLen(value, minLength);
                    if (!retObj.result) {
                        return retObj;
                    }
                    retObj = dv.maxLen(value, maxLength);
                    return retObj;
                },
                password: function (pwd, policy, userNameId, pwdMinLen){
                    var pwdPolicy = policy.passwordpolicy;
                    var retObj = dv.notBlank(pwd, false);
                    if (!retObj.result) {
                        retObj.cases="not-blank";
                        return retObj;
                    }
                    retObj = dv.minLen(pwd, pwdMinLen ? pwdMinLen : pwdPolicy.password_minlen);
                    if (!retObj.result) {
                        retObj.cases="min-len";
                        return retObj;
                    }
                    retObj = dv.maxLen(pwd, pwdPolicy.password_maxlen);
                    if (!retObj.result) {
                        retObj.cases="max-len";
                        return retObj;
                    }

                    if(userNameId && pwdPolicy.pwd_not_is_the_username_or_invert === "true")
                    {
                        retObj = dv.notEqualOrInvert(pwd, userNameId, me.i18n("pwdNotUsernameOrInvert"));
                        if(!retObj.result){
                            retObj.cases="conf-name";
                            return retObj;
                        }
                    }
                    return retObj;
                },
                email: function (value){
                    var retObj = dv.notEmpty(value, true);
                    if (!retObj.result) {
                        return retObj;
                    }
                    retObj = dv.emailCheck(value);
                    if (!retObj.result) {
                        return retObj;
                    }
                    retObj = dv.checkCharLength(value, 255);
                    if (!retObj.result) {
                        return retObj;
                    }
                    retObj = dv.maxLen(value, 255);
                    return retObj;
                },
                phone: function (value, phoneLen){
                    var retObj = dv.notEmpty(value, true);
                    if (!retObj.result) {
                        return retObj;
                    }
                    retObj = dv.phoneCheck(value);
                    if (!retObj.result) {
                        return retObj;
                    }
                    var length = phoneLen ? phoneLen: 32;
                    retObj = dv.maxLen(value, length, me.i18n("phoneMaxLenTxt"));
                    return retObj;
                },
                phoneAdd: function(value){
                    var retObj = dv.notEmpty(value, true);
                    if (!retObj.result) {
                        return retObj;
                    }
                    retObj = dv.phoneAddCheck(value);
                    if (!retObj.result) {
                        return retObj;
                    }
                    retObj = dv.maxLen(value, 11, me.i18n("phoneMaxLenTxt"));
                    return retObj;
                },
                confirmPwd: function (value, pwdId){
                    var retObj = dv.notBlank(value, false);
                    if (!retObj.result) {
                        return retObj;
                    }
                    retObj = dv.equal(value, pwdId, me.i18n("passwordEqual"));
                    return retObj;
                },
                msgCode: function (value){
                    var retObj = dv.notEmpty(value, true);
                    if (!retObj.result) {
                        return retObj;
                    }
                    retObj = dv.msgCodeCheck(value);
                    if (!retObj.result) {
                        return retObj;
                    }
                    retObj = dv.maxLen(value, 8, me.i18n("maxLenTxt"));
                    return retObj;
                },
                smsMsgCode: function (value){
                    var retObj = dv.notEmpty(value, true);
                    if (!retObj.result) {
                        return retObj;
                    }
                    retObj = dv.smsMsgCodeCheck(value);
                    if (!retObj.result) {
                        return retObj;
                    }
                    retObj = dv.maxLen(value, 6, me.i18n("maxLenTxt"));
                    return retObj;
                },
                graphVerifyCode: function (value){
                    var retObj = dv.notBlank(value, true);
                    if (!retObj.result) {
                        return retObj;
                    }
                    retObj = dv.maxLen(value, 4);
                    return retObj;
                },
                childValidator: me.directValidator
            };
        };

        function DirectValidator(i18n) {
            this.i18n = i18n;
        }

        function getRetObj(result, err) {
            return {
                result: result,
                errorInfo: err
            };
        }

        DirectValidator.prototype.notBlank = function (value, notContainSpace) {
            if (value === undefined || value.length === 0) {
                return getRetObj(false, this.i18n("blankTxt"));
            }

            if (notContainSpace && value.indexOf(" ") !== -1)
            {
                return getRetObj(false, this.i18n("emptyTxt"));
            }
            return getRetObj(true);
        };

        DirectValidator.prototype.notEmpty = function (value, notContainSpace) {
            if (notContainSpace && (value === undefined || value.indexOf(" ") !== -1 || value.length === 0))
            {
                return getRetObj(false, this.i18n("emptyTxt"));
            }

            if (!value || $.trim(value.toString()).length === 0) {
                return getRetObj(false, this.i18n("blankTxt"));
            }
            return getRetObj(true);
        };

        DirectValidator.prototype.maxLen = function (value, maxLen, errorDetail) {
            var maxLenNum = Number(maxLen);
            if (isNaN(maxLenNum))
            {
                maxLenNum = 255;
            }
            if(!errorDetail)
            {
                errorDetail = this.i18n("maxLenTxt");
            }
            return value.length > maxLenNum ? getRetObj(false, utils.i18nFormat(errorDetail, maxLenNum)) : getRetObj(true);
        };

        DirectValidator.prototype.minLen = function (value, minLen, errorDetail) {
            var minLenNum = Number(minLen);
            if (isNaN(minLenNum))
            {
                minLenNum = 0;
            }
            if(!errorDetail)
            {
                errorDetail = this.i18n("minLenTxt");
            }
            return value.length < minLenNum ? getRetObj(false, utils.i18nFormat(errorDetail, minLenNum)) : getRetObj(true);
        };

        DirectValidator.prototype.validInput = function (value, regExpStr, errorDetail) {
            if (!value) {
                return getRetObj(true);
            }
            var pattern = new RegExp(regExpStr);
            var result = pattern.test(value);
            return result ? getRetObj(true) : getRetObj(false, errorDetail);
        };

        DirectValidator.prototype.notEqualOrInvert = function (value, compareId, errorDetail) {
            var targetValue = "";
            var targetWidget = undefined;

            try{
                targetWidget = $("#" + compareId).widget();
            }catch(e){
                targetValue = compareId;
            }

            if (targetWidget) {
                targetValue = targetWidget.getValue();
            } else if(targetValue === "") {
                //just span
                targetValue = $("#" + compareId).html();
                if (!targetValue) {
                    targetValue = compareId;
                }
            }

            if (value && (value.toLowerCase() === targetValue.toLowerCase() || value.toLowerCase() === targetValue.split("").reverse().join("").toLowerCase())) {
                return getRetObj(false, errorDetail);
            }
            return getRetObj(true);
        };

        DirectValidator.prototype.equal = function (value, compareId, errorDetail) {
            if ($("#" + compareId).widget().getValue() !== value) {
                return getRetObj(false, errorDetail);
            }
            return getRetObj(true);
        };

        DirectValidator.prototype.emailCheck = function (value) {
            var pattern = /^((([A-Za-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([A-Za-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([A-Za-z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([A-Za-z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/;
            return pattern.test(value) ? getRetObj(true) : getRetObj(false, this.i18n("validEmail"));
        };

        DirectValidator.prototype.phoneCheck = function (value) {
            var pattern = /^[0-9]\d*$/;
            return pattern.test(value) ? getRetObj(true) : getRetObj(false, this.i18n("validPhone"));
        };

        DirectValidator.prototype.phoneAddCheck = function (value) {
            var pattern = /^1\d{10}$/;
            return pattern.test(value) ? getRetObj(true) : getRetObj(false, this.i18n("validPhone"));
        };

        DirectValidator.prototype.checkCharLength = function (value, maxLen) {
            var charLength = 0;
            for (var i = 0; i < value.length; i++){
                if ((value.charCodeAt(i)>=0) && (value.charCodeAt(i)<=255)){
                    charLength = charLength +1;
                }
                else{
                    charLength = charLength +2;
                }
            }
            return charLength > maxLen ? getRetObj(false, utils.i18nFormat(this.i18n("maxLenTxt"), maxLen)) : getRetObj(true);
        };
        
        DirectValidator.prototype.msgCodeCheck = function (value) {
            var pattern = /^[a-zA-Z0-9]*$/;
            return pattern.test(value) ? getRetObj(true) : getRetObj(false, this.i18n("commonContainsChar"));
        };

        DirectValidator.prototype.smsMsgCodeCheck = function (value) {
            var pattern = /^[0-9]*$/;
            return pattern.test(value) ? getRetObj(true) : getRetObj(false, this.i18n("msgCodeErrorInfo"));
        };

        return IAMValidator;
});


// WEBPACK FOOTER //
// ./public/base/utils/iamValidator.js